"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCameraMovie(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M16.085 10.212c.935 0 1.707.725 1.781 1.641l.006.147v1.987l5.121-1.693a.766.766 0 011 .625l.007.102v8.17a.766.766 0 01-.907.753l-.1-.026-5.121-1.693v1.987a1.79 1.79 0 01-1.64 1.782l-.147.006H1.787a1.79 1.79 0 01-1.781-1.641L0 22.212V12c0-.935.724-1.707 1.641-1.782l.146-.006h14.298zm0 1.532H1.787a.26.26 0 00-.248.198L1.532 12v10.212a.26.26 0 00.197.249l.058.007h14.298a.26.26 0 00.249-.198l.006-.058V19.146a.76.76 0 01.003-.05l-.003.069a.771.771 0 01.036-.232l.003-.009.006-.016a.76.76 0 01.025-.063l-.03.08a.77.77 0 01.543-.504.825.825 0 01.183-.022h.02a.76.76 0 01.049.003l-.069-.003a.771.771 0 01.14.013l.028.005a.76.76 0 01.056.015l.017.006 5.121 1.692v-6.05l-5.121 1.695-.018.006a.76.76 0 01-.051.014l.069-.02a.772.772 0 01-.221.039H17.068a.761.761 0 01-.038-.004l.076.004a.77.77 0 01-.652-.364.84.84 0 01-.036-.065l-.008-.017a.76.76 0 01-.025-.063l-.006-.016a.755.755 0 01-.022-.082l.022.082a.772.772 0 01-.032-.137l-.004-.035a.76.76 0 01-.003-.05V12a.26.26 0 00-.197-.249l-.058-.007zM13.021 0a4.851 4.851 0 110 9.702 4.851 4.851 0 010-9.702zM3.83 2.043a3.83 3.83 0 11-.001 7.66 3.83 3.83 0 010-7.66zm9.191-.511a3.32 3.32 0 100 6.639 3.32 3.32 0 000-6.64zM3.83 3.574a2.298 2.298 0 100 4.597 2.298 2.298 0 000-4.597z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCameraMovie;
exports.default = _default;